const getApiUrl = (): string => {
  const apiByOrigin: Record<string, string> = {
    // Localhost
    'http://localhost:5175': 'http://localhost:8080',
    'http://localhost:5176': 'http://localhost:8080',
    'http://localhost:5174': 'http://localhost:8080',
    'http://localhost:5173': 'http://localhost:8080',
    // Provelab
    'https://provelab.sample-dev.mattilsynet.io':
      'https://sample.sample-dev.mattilsynet.io',
    'https://provelab.sample-training.mattilsynet.io':
      'https://sample.sample-training.mattilsynet.io',
    'https://provelab.sample.mattilsynet.io':
      'https://sample.sample.mattilsynet.io',
    // Proveadmin
    'https://proveadmin.sample-dev.mattilsynet.io':
      'https://sample.sample-dev.mattilsynet.io',
    'https://proveadmin.sample-training.mattilsynet.io':
      'https://sample.sample-training.mattilsynet.io',
    'https://proveadmin.sample.mattilsynet.io':
      'https://sample.sample.mattilsynet.io',
    // Proveta
    'https://proveta.sample-dev.mattilsynet.io':
      'https://sample.sample-dev.mattilsynet.io',
    'https://proveta.sample-training.mattilsynet.io':
      'https://sample.sample-training.mattilsynet.io',
    'https://proveta.sample.mattilsynet.io':
      'https://sample.sample.mattilsynet.io',
    // Proveplan
    'https://proveplan.sample-dev.mattilsynet.io':
      'https://sample.sample-dev.mattilsynet.io',
    'https://proveplan.sample-training.mattilsynet.io':
      'https://sample.sample-training.mattilsynet.io',
    'https://proveplan.sample.mattilsynet.io':
      'https://sample.sample.mattilsynet.io'
  }

  return (
    apiByOrigin[globalThis.location.origin] ??
    `${globalThis.location.origin}/api`
  )
}
export const BASE_URL = getApiUrl()
